const adaptProductForm = (form = {}) => {
  const results = { product: {}, referenced_tables: {}};

  for (let fieldName in form) {
    const isReferencedTableData = /.*_data/.test(fieldName);
    const subfield = isReferencedTableData ? 'referenced_tables' : 'product';
    if (fieldName === 'sizes_data') {
      results.product.sizes_data = JSON.stringify(form[fieldName]);
    }
    if (isReferencedTableData && fieldName !== 'sizes_data') {
      let recordKeys = {};
      if (Array.isArray(form[fieldName])) {
        form[fieldName].forEach((value) => {
          recordKeys[value.id] = { count: value.count }
        });
      }
      results[subfield][fieldName] = recordKeys;
    }
    if (!isReferencedTableData) {
      results[subfield][fieldName] = form[fieldName];
    }
  }

  const objectFields = ['parent', 'cut_of_clothes', 'package_item'];
  objectFields.forEach((name) => {
    const isPackage = !!(name === 'package_item');
    const fieldName = isPackage ? 'package_id' : `${name}_id`;
    let value = null;
    if (results.product[name]) {
      value = results.product[name].id;
    }
    results.product[fieldName] = value;
    delete results.product[name];
  });

  return results;
};

const requestAdapter = {
  adaptProductForm,
};

export default requestAdapter;



// WEBPACK FOOTER //
// ./src/stock/api-services/_requestAdapter.js